'use client';

import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { CryptoIcon } from '@/components/ui/CryptoIcon';
import { formatPnlColor, humanFormatNumber } from '@/lib/utils/format';
import TouchOpacity from '../ui/TouchableOpacity';

interface TradeStoryOverviewProps {
  symbol: string;
  tradeCount: number;
  pnl: number;
  onPress?: () => void;
}

export function TradeStoryOverview({
  symbol,
  tradeCount,
  pnl,
  onPress,
}: TradeStoryOverviewProps) {
  const isProfit = pnl >= 0;
  const isZero = pnl === 0;

  return (
    <TouchOpacity
      onClick={onPress}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={'2px'}
      rounded="md"
      px={'6px'}
      py={1}
      border="0.5px solid"
      minW="fit-content"
      w="max-content"
      flexShrink={0}
      bg={
        isProfit && !isZero
          ? 'profit/15'
          : !isZero
            ? 'loss/15'
            : 'foreground/10'
      }
      borderColor={
        isProfit && !isZero ? 'profit' : !isZero ? 'loss' : 'foreground/30'
      }
    >
      {/* Token Info Row */}
      <HStack gap={1} align="center">
        <CryptoIcon symbol={symbol} size={16} />
        <Text
          fontSize="2xs"
          fontWeight="medium"
          color={formatPnlColor(isZero, isProfit)}
          whiteSpace="nowrap"
        >
          {symbol} ({tradeCount})
        </Text>
      </HStack>
      {/* PnL Amount */}
      <Text
        fontSize="xs"
        fontWeight="medium"
        color={formatPnlColor(isZero, isProfit)}
        whiteSpace="nowrap"
      >
        {pnl > 0 ? '+$' : '-$'}
        {humanFormatNumber(Math.abs(pnl))}
      </Text>
    </TouchOpacity>
  );
}
